import { Component, computed } from '@angular/core';
import { ToastModule, ToastPassThrough } from 'primeng/toast';
import { FileUploadModule } from 'primeng/fileupload';
import { ProgressBarModule } from 'primeng/progressbar';
import { CommonModule } from '@angular/common';
import { VectorComponent } from '../../../../../components/vector/vector';
import { BaseButtonComponent } from '../../../base-button/base-button';
import { DomainVersioningTypeToast, toastKey } from '../../../../../models/enums';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { getDomainVersioningToastStyling } from './helpers/base-domain-versioning-helper';
import { TruncateTooltipDirective } from '../../../../../helpers/directives/truncate-tooltip';

@Component({
  selector: 'app-domain-versioning-toast',
  standalone: true,
  imports: [ToastModule, VectorComponent, FileUploadModule, BaseButtonComponent, ProgressBarModule, CommonModule, NgbTooltip, TruncateTooltipDirective],
  templateUrl: './domain-versioning-toast.html',
  styleUrl: './domain-versioning-toast.scss'
})
export class DomainVersioningToastComponent {
  protected readonly toastKey = toastKey;
  protected readonly DomainVersioningTypeToast = DomainVersioningTypeToast;

  domainVersioningToastPT = computed<ToastPassThrough>(() => getDomainVersioningToastStyling());
}
